module.exports = __webpack_public_path__ + "static/media/personality.139f93f4.png";